import { render, staticRenderFns } from "./search_background_overlay.vue?vue&type=template&id=5077f126&scoped=true&"
import script from "./search_background_overlay.vue?vue&type=script&lang=js&"
export * from "./search_background_overlay.vue?vue&type=script&lang=js&"
import style0 from "./search_background_overlay.vue?vue&type=style&index=0&id=5077f126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077f126",
  null
  
)

export default component.exports